import axios from 'axios'
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import {loadProcessToken } from "../actions/index";

export const LOAD_PROJECTS = "LOAD_PROJECTS";
export const CHANGE_PROJECT = "CHANGE_PROJECT";
export const CREATE_PROJECT = "CREATE_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const LOAD_PROJECT_DASHBOARD = "LOAD_PROJECT_DASHBOARD";
export const LOAD_PROJECT_DASHBOARD_FAILURE = "LOAD_PROJECT_DASHBOARD_FAILURE";
export const LOAD_PROJECT_NEWNESS = "LOAD_PROJECT_NEWNESS";
export const LOAD_PROJECT_NEWNESS_FAILURE = "LOAD_PROJECT_NEWNESS_FAILURE";
export const LOAD_CLASS_NEWNESS = "LOAD_CLASS_NEWNESS";
export const LOAD_CLASS_NEWNESS_FAILURE = "LOAD_CLASS_NEWNESS_FAILURE";

export const LOAD_PROJECT_ROBUSTNESS = "LOAD_PROJECT_ROBUSTNESS";
export const LOAD_PROJECT_ROBUSTNESS_FAILURE = "LOAD_PROJECT_ROBUSTNESS_FAILURE";
export const LOAD_CLASS_ROBUSTNESS = "LOAD_CLASS_ROBUSTNESS";
export const LOAD_CLASS_ROBUSTNESS_FAILURE = "LOAD_CLASS_ROBUSTNESS_FAILURE";

export const LOAD_TRAINING = "LOAD_TRAINING";
export const LOAD_TRAINING_FAILURE = "LOAD_TRAINING_FAILURE";

export const LOAD_DATA = "LOAD_DATA";
export const LOAD_DATA_FAILURE = "LOAD_DATA_FAILURE";

export const LOAD_FILE= "LOAD_FILE";
export const LOAD_FILE_FAILURE = "LOAD_FILE_FAILURE";


export const loadProjects = (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        axios.get(config.API_URL + 'aiservice/projects').then(({ data }) => {
            dispatch({
                type: LOAD_PROJECTS,
                payload: _.filter(data, { 'status': 'ACTIVE' })
            });
        }).catch(function (error) {
            console.log(error);
            if (error.response) {
               console.log("error response");
               console.log(error.response);
               toastr.error('Failed to retrieve projects:', error.response.data.error);
            } else {
               toastr.error('Failed to retrieve projects:', error.message);
            }
        });
    }
}

export const createProject = (props, scope) => {
    let token = loadProcessToken();
    if (props._id) {
        return (dispatch, getState) => {
            axios.put(config.API_URL + 'aiservice/projects', props).then(({ data }) => {
                dispatch({
                    type: UPDATE_PROJECT,
                    payload: data
                });

                toastr.success('Successfully update the project');
            }).catch(function (error) {
                toastr.error('Failed to update project', error.response.data.error);
            });
        }
    } else {
        return (dispatch, getState) => {
            axios.post(config.API_URL + 'aiservice/projects', props).then(({ data }) => {
                dispatch({
                    type: CREATE_PROJECT,
                    payload: data
                });
                toastr.success('Successfully created the project');
            }).catch(function (error) {
                toastr.error('Failed to create project', error.response.data.error);
            });
        }
    }
}

const callDashboardAPI = (props, dispatch) => {
    let token = loadProcessToken();
    axios.get(config.PROJECT_DASHBOARD_API_URL + `aiservice/project_report?project=${props.name}&storage_type=${props.storageType}&data_type=${props.dataType}`).then(({ data }) => {
        dispatch({
            type: LOAD_PROJECT_DASHBOARD,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           console.log("error response");
           console.log(error.response);
           toastr.error('Failed to retrieve dashboard report:', error.response.data.Error);
           dispatch({
              type: LOAD_PROJECT_DASHBOARD_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to retrieve dashboard report:');
           dispatch({
              type: LOAD_PROJECT_DASHBOARD_FAILURE,
              dataLoaded:false,
              error: 'Failed to retrieve dashboard report:'
          });
        }
    });
}

const callDataAPI = (props, dispatch) => {
    let token = loadProcessToken();
    axios.get(config.PROJECT_DASHBOARD_API_URL + `aiservice/items_in_folder?project=${props.name}&storage_type=${props.storageType}&data_type=${props.dataType}`).then(({ data }) => {
        dispatch({
            type: LOAD_DATA,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           console.log("error response");
           console.log(error.response);
           toastr.error('Did not find any data files:', error.response.data.Error);
           dispatch({
              type: LOAD_DATA_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Did not find any data files');
           dispatch({
              type: LOAD_DATA_FAILURE,
              dataLoaded:false,
              error: 'Did not find any data files'
          });
        }
    });
}


const callLoadFileAPI = (selected_project,file, dispatch) => {
    let token = loadProcessToken();
    console.log("Calling API");
    console.log(file);
    let url = null;
    if (file.extension =="png"){
       url = config.PROJECT_DASHBOARD_API_URL + `aiservice/load_image?project=${selected_project.name}&storage_type=${selected_project.storageType}&data_type=${selected_project.dataType}&file_path=${file.key}`;
    } else {
       url = config.PROJECT_DASHBOARD_API_URL + `aiservice/load_json?project=${selected_project.name}&storage_type=${selected_project.storageType}&data_type=${selected_project.dataType}&file_path=${file.key}`;
    }
    console.log(url);
    axios.get(url).then(({ data }) => {
        dispatch({
            type: LOAD_FILE,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           console.log("error response");
           console.log(error.response);
           toastr.error('Failed to load image:', error.response.data.Error);
           dispatch({
              type: LOAD_FILE_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to load image');
           dispatch({
              type: LOAD_FILE_FAILURE,
              dataLoaded:false,
              error: 'Failed to load image'
          });
        }
    });
}


const callNewnessAPI = (selected_project, child_name, dispatch) => {
    let token = loadProcessToken();
    var url = config.PROJECT_DASHBOARD_API_URL + `aiservice/newness_summary?project=${selected_project.name}&storage_type=${selected_project.storageType}&data_type=${selected_project.dataType}`
    if (child_name){
      url = url + `&child_name=${child_name}`
    }
    axios.get(url).then(({ data }) => {
        dispatch({
            type: LOAD_PROJECT_NEWNESS,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           console.log("error response");
           console.log(error.response);
           toastr.error('Failed to retrieve newness data:', error.response.data.Error);
           dispatch({
              type: LOAD_PROJECT_NEWNESS_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to retrieve newness data:');
           dispatch({
              type: LOAD_PROJECT_NEWNESS_FAILURE,
              dataLoaded:false,
              error: 'Failed to retrieve newness data:'
          });
        }
    });
}

const callRobustnessAPI = (props, dispatch) => {
    let token = loadProcessToken();
    console.log("robustness summary action");
    var url = config.PROJECT_DASHBOARD_API_URL + `aiservice/rbst_summary?project=${props.name}&storage_type=${props.storageType}&data_type=${props.dataType}`;
    console.log(url);
    axios.get(url).then(({ data }) => {
        dispatch({
            type: LOAD_PROJECT_ROBUSTNESS,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           toastr.error('Failed to retrieve newness data:', error.response.data.title);
           dispatch({
              type: LOAD_PROJECT_ROBUSTNESS_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to retrieve newness data:');
           dispatch({
              type: LOAD_PROJECT_ROBUSTNESS_FAILURE,
              dataLoaded:false,
              error: 'Failed to retrieve newness data:'
           });
        }
    });
}

const callClassNewnessAPI = (selected_project,class_label, dispatch) => {
    let token = loadProcessToken();
    var url = config.PROJECT_DASHBOARD_API_URL + `aiservice/newness_class?project=${selected_project.name}&storage_type=${selected_project.storageType}&data_type=${selected_project.dataType}&class=${class_label}`;
    console.log(url);
    axios.get(url).then(({ data }) => {
        dispatch({
            type: LOAD_CLASS_NEWNESS,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
         console.log(error)
         if (error.response) {
           toastr.error('Failed to retrieve class newness data:', error.response.data.title);
           dispatch({
              type: LOAD_CLASS_NEWNESS_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to retrieve class newness data:');
           dispatch({
              type: LOAD_CLASS_NEWNESS_FAILURE,
              dataLoaded:false,
              error: 'Failed to retrieve class newness data:'
          });
        }

    });
}

const callClassRobustnessAPI = (selected_project,class_label, bdg_type, dispatch) => {
    let token = loadProcessToken();
    console.log(class_label);
    console.log(bdg_type);

    var url = config.PROJECT_DASHBOARD_API_URL + `aiservice/rbst_class?project=${selected_project.name}&storage_type=${selected_project.storageType}&data_type=${selected_project.dataType}&class=${class_label}&type=${bdg_type}`;
    console.log(url);
    axios.get(url).then(({ data }) => {
        dispatch({
            type: LOAD_CLASS_ROBUSTNESS,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
         console.log(error)
         if (error.response) {
           toastr.error('Failed to retrieve class robustness data:', error.response.data.title);
           dispatch({
              type: LOAD_CLASS_ROBUSTNESS_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
         } else{
            toastr.error('Failed to retrieve class robustness data:');
            dispatch({
                type: LOAD_CLASS_ROBUSTNESS_FAILURE,
                dataLoaded:false,
                error: "Failed to retrieve class robustness data"
            });
         }
    });
}



const callTrainingAPI = (selected_project, child_name, training_type, dispatch) => {
    let token = loadProcessToken();
    var url = config.PROJECT_DASHBOARD_API_URL + `aiservice/training_summary?project=${selected_project.name}&storage_type=${selected_project.storageType}&data_type=${selected_project.dataType}&training_type=${training_type}`;
    if (child_name){
        url =url + `&child_name=${child_name}`
    }

    console.log(url);

    axios.get(url).then(({ data }) => {
        dispatch({
            type: LOAD_TRAINING,
            dataLoaded:true,
            payload: data
        });
    }).catch(function (error) {
        if (error.response) {
           console.log("error response");
           console.log(error.response);
           toastr.error('Failed to retrieve training data:', error.response.data.Error);
           dispatch({
              type: LOAD_TRAINING_FAILURE,
              dataLoaded:false,
              error: error.response.data.Error
          });
        } else {
          toastr.error('Failed to retrieve training data:');
           dispatch({
              type: LOAD_TRAINING_FAILURE,
              dataLoaded:false,
              error: 'Failed to retrieve training data:'
          });
        }
    });
}

export const changeProject = (props, scope) => {
    let token = loadProcessToken();
    return (dispatch) => {
        dispatch({
            type: CHANGE_PROJECT,
            payload: props
        });
        if (props) {
            callDashboardAPI(props, dispatch);
        }
    };
}

export const deleteProject = (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        axios.delete(config.API_URL + 'aiservice/projects/' + props._id).then(({ data }) => {
            dispatch({
                type: DELETE_PROJECT,
                payload: props._id
            });
            toastr.success('Successfully delete the project');
        }).catch(function (error) {
            toastr.error('Failed to delete project', error.response.data.title);
        });
    }
}

export const loadDashboard = (props, scope) => {
    return (dispatch, getState) => {
        callDashboardAPI(props, dispatch);
    }
}


export const loadDataViewer= (props, scope) => {
    return (dispatch, getState) => {
        callDataAPI(props, dispatch);
    }
}

export const loadFileData= (selected_project, file, scope) => {
    console.log("Loading file data");
    return (dispatch, getState) => {
        callLoadFileAPI(selected_project, file, dispatch);
    }
}

export const loadNewness= (selected_project, child_name, scope) => {
    return (dispatch, getState) => {
        callNewnessAPI(selected_project, child_name,  dispatch);
    }
}

export const loadClassNewness= (selected_project, class_label, scope) => {
    return (dispatch, getState) => {
        callClassNewnessAPI(selected_project,class_label, dispatch);
    }
}

export const loadRobustness= (props, scope) => {
    console.log("dispatching action for robustness");
    console.log(props);
    var url = config.PROJECT_DASHBOARD_API_URL + `aiservice/rbst_summary?project=${props.name}&storage_type=${props.storageType}&data_type=${props.dataType}`;
    console.log(url);
    return (dispatch, getState) => {
        callRobustnessAPI(props, dispatch);
    }
}


export const loadClassRobustness= (selected_project, class_label, bdg_type, scope) => {
    return (dispatch, getState) => {
        callClassRobustnessAPI(selected_project,class_label, bdg_type, dispatch);
    }
}

export const loadTraining= (selected_project, child_name, training_type, scope) => {
    return (dispatch, getState) => {
        callTrainingAPI(selected_project, child_name, training_type, dispatch);
    }
}

export const sendSelectedFile= (file, scope) => {
    return (dispatch, getState) => {
         dispatch({
                type: "UPDATE_SELECTED_FILE",
                payload: file
         });
    }
}



// WEBPACK FOOTER //
// ./src/actions/projects.js